import React from 'react'

export default function ArrowDown() {
    return (
        <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.43669 9.35429C3.63238 9.54913 3.94896 9.54845 4.1438 9.35277L7.31893 6.16396C7.51378 5.96828 7.51309 5.6517 7.31741 5.45685C7.12173 5.26201 6.80515 5.26269 6.61031 5.45837L3.78797 8.29287L0.953467 5.47053C0.757786 5.27569 0.441204 5.27637 0.246362 5.47205C0.0515198 5.66773 0.0522003 5.98432 0.247882 6.17916L3.43669 9.35429ZM3.27014 0.00107475L3.28949 9.00105L4.28949 8.9989L4.27014 -0.00107475L3.27014 0.00107475Z" fill="#696969" />
        </svg>

    )
}
